<div class="absolute inset-0 overflow-hidden flex flex-col flex-auto mt-6">
  <form [formGroup]="form" class="flex flex-col flex-auto overflow-auto">
    <mat-accordion class="example-headers-align" multi togglePosition="before">
      <!-- General Info -->
      <div class="flex flex-col px-6 relative" *ngIf="!isDetail">
        <mat-expansion-panel expanded="true" class="border border-solid border-theme-line mat-elevation-z0">
          <mat-expansion-panel-header class="bg-theme-line" expandedHeight="28px">
            <mat-panel-title class="font-semibold"> General </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <div class="lg:absolute relative lg:top-6 lg:left-6 font-semibold text-s1">General</div> -->
          <div class="flex flex-col flex-auto lg:max-w-[1200px] lg:mx-auto lg:my-0 w-full">
            <div class="flex flex-col flex-auto mt-3 lg:mt-5">
              <!-- Report Type - Report Name -->
              <div class="flex flex-col lg:flex-row lg:gap-6">
                <mat-form-field class="w-full" appearance="fill">
                  <mat-label>Report Type</mat-label>
                  <mat-select formControlName="reportType">
                    <mat-option *ngFor="let item of reportTypes" [value]="item?.id">
                      {{ item?.name | titlecase }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('reportType')?.hasError('required')">This field is required</mat-error>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="fill">
                  <mat-label>Report Name</mat-label>
                  <textarea matInput formControlName="name" type="text" rows="1"></textarea>
                  <mat-error *ngIf="form.get('name')?.hasError('required')">This field is required</mat-error>
                  <mat-error *ngIf="form.get('name')?.hasError('maxChar')"> Maximum 200 character</mat-error>
                  <mat-error *ngIf="form.get('name')?.hasError('invalidFileName')"> Report name cannot contain: / \ : * ? " < > |</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- <div class="mt-4">
              <mat-divider></mat-divider>
            </div> -->
        </mat-expansion-panel>
      </div>

      <!-- Include Columns -->
      <div class="flex flex-col px-6 relative" *ngIf="!isDetail">
        <mat-expansion-panel expanded="true" class="border border-solid border-theme-line mat-elevation-z0">
          <mat-expansion-panel-header class="bg-theme-line" expandedHeight="28px">
            <mat-panel-title class="font-semibold"> Include Columns </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <div class="lg:absolute relative lg:top-6 lg:left-6 font-semibold text-s1">Include Columns</div> -->
          <div class="flex flex-col flex-auto lg:max-w-[1200px] lg:mx-auto lg:my-0 w-full">
            <div class="flex flex-col flex-auto mt-3 lg:mt-5">
              <div class="flex flex-col lg:flex-row lg:gap-6">
                <mat-form-field class="w-full" appearance="fill">
                  <mat-label>Select Columns (Maximum 30 columns)</mat-label>
                  <mat-select matInput formControlName="customColumns" multiple [compareWith]="compareWithColumn">
                    <mat-select-trigger *ngIf="form.get('customColumns')?.value?.length > 0">
                      <div class="inline-flex items-baseline overflow-hidden w-full">
                        <div class="truncate mr-1">Number of columns</div>
                        <mat-chip-list>
                          <mat-chip color="primary" selected>{{ columnsSelection.length }}</mat-chip>
                        </mat-chip-list>
                      </div>
                    </mat-select-trigger>
                    <mat-option>
                      <red-select-search [formControl]="columnsSearcher.searchCtrl" [searching]="columnsSearcher.loading"></red-select-search>
                    </mat-option>
                    <mat-option (onSelectionChange)="addColumn($event, null, true)"> Select All </mat-option>
                    <mat-option *ngFor="let item of columnsSearcher.results | async; let i = index" [value]="item" (onSelectionChange)="addColumn($event, item)">
                      {{ item.displayName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('customColumns')?.hasError('required')">This field is required</mat-error>
                  <mat-error *ngIf="form.get('customColumns')?.hasError('maxColumns')">Maximum 30 columns</mat-error>
                </mat-form-field>

                <div class="mt-6 w-[50px]"><mat-icon>fast_forward</mat-icon></div>
                <div class="mt-2 w-full">
                  <table class="w-full table-auto border-collapse" cdkDropList (cdkDropListDropped)="dropColumn($event)">
                    <thead>
                      <tr class="bg-gray-100 text-gray-500 text-xs border-l">
                        <th class="w-24 text-center px-2">
                          <div class="flex items-center justify-center">
                            <div class="mx-2">SN</div>
                            <button mat-icon-button type="button" (click)="sortColumn()">
                              <mat-icon class="text-primary">refresh</mat-icon>
                            </button>
                          </div>
                        </th>
                        <th class="text-left border-l border-r p-4">Selected Column</th>
                        <th class="w-16 text-center border-r p-4"></th>
                      </tr>
                    </thead>
                    <tbody class="text-gray-800 text-s2">
                      <tr class="border-b" *ngFor="let col of columnsSelection; let i = index" cdkDrag>
                        <td class="w-24 cursor-grab border-l p-2">
                          <span class="flex items-center justify-center text-center text-lg text-gray-800">
                            <button cdkDragHandle mat-icon-button type="button">
                              <mat-icon>drag_indicator</mat-icon>
                            </button>
                            <input matInput type="number" min="0" [value]="col.sequence" (change)="changeSequenceColumn($event, col, i + 1)" />
                          </span>
                        </td>
                        <td class="border-r border-l p-2">{{ col.displayName }}</td>
                        <td class="text-center cursor-grab border-r p-2">
                          <span class="text-lg text-gray-800">
                            <button mat-icon-button (click)="removeColumn(col)">
                              <mat-icon class="text-primary">delete</mat-icon>
                            </button>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- <mat-table class="stretch-table" [dataSource]="columnFormArray?.value" cdkDropList (cdkDropListDropped)="dropColumn($event)">
                  <ng-container matColumnDef="sn">
                    <mat-header-cell *matHeaderCellDef> SN </mat-header-cell>
                    <mat-cell *matCellDef="let row; let i = index">
                      <div>
                        <button cdkDragHandle mat-icon-button type="button">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                      </div>
                    </mat-cell>
                  </ng-container>
  
                  <ng-container matColumnDef="columnName">
                    <mat-header-cell *matHeaderCellDef>Selected Column</mat-header-cell>
                    <mat-cell *matCellDef="let item; let i = index">
                      {{ item?.displayName }}
                      <div *ngFor="let ittt of form.get('customColumns')?.value">{{ ittt?.displayName }}</div>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="['sn', 'columnName']"></mat-header-row>
  
                  <mat-row
                    class="highlight-row-hover"
                    *matRowDef="let row; columns: ['sn', 'columnName']"
                    routerLinkActive="row-actived"
                    queryParamsHandling="merge"
                    cdkDrag
                  >
                  </mat-row>
                </mat-table> -->
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>

      <!-- Filter -->
      <div class="flex flex-col px-6 relative filter-dynamic-report" *ngIf="form?.get('reportType')?.value && form?.get('customColumns')?.value?.length > 0">
        <mat-expansion-panel expanded="true" class="border border-solid border-theme-line mat-elevation-z0">
          <mat-expansion-panel-header class="bg-theme-line" expandedHeight="28px">
            <mat-panel-title class="font-semibold"> Include Filter </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- <div class="lg:absolute relative lg:top-6 lg:left-6 font-semibold text-s1">Include Filter</div> -->
          <div class="flex flex-col flex-auto lg:max-w-[1200px] lg:mx-auto lg:my-0 w-full">
            <div class="flex flex-col flex-auto lg:mt-5" formGroupName="config">
              <mat-radio-group class="mt-3" color="primary" formControlName="combineType">
                <mat-radio-button class="mr-4 text-b2 text-black" *ngFor="let option of typeSearchOptions" [value]="option.value">{{
                  option.viewValue
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="flex flex-col flex-auto mt-3 lg:mt-5" formArrayName="parameters">
              <ng-container *ngFor="let paramControl of parameterFormArray.controls; let i = index">
                <div class="flex flex-col lg:flex-row items-center lg:gap-6 pt-6 px-6 mb-2 bg-theme-line" [formGroupName]="i">
                  <mat-form-field class="w-full" appearance="fill">
                    <mat-label>Where</mat-label>
                    <input matInput formControlName="column" class="hidden" />
                    <mat-select formControlName="param" [compareWith]="compareWithColumn" (selectionChange)="addParameter($event, paramControl)">
                      <mat-option>
                        <red-select-search [formControl]="parametersSearcher.searchCtrl" [searching]="parametersSearcher.loading"></red-select-search>
                      </mat-option>
                      <mat-option *ngIf="paramControl?.get('param')?.value?.column" [value]="paramControl.get('param')?.value">
                        {{ paramControl.get('param')?.value?.displayName }}
                      </mat-option>
                      <ng-container *ngFor="let item of parametersSearcher.results | async; let idx = index">
                        <mat-option [value]="item" *ngIf="checkParamsSection(item.alias + '.' + item.column)">
                          {{ item.displayName }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                    <mat-error *ngIf="paramControl?.get('column')?.hasError('required')">This field is required</mat-error>
                  </mat-form-field>
                  <mat-form-field class="w-full" appearance="fill">
                    <mat-label>Condition</mat-label>
                    <mat-select matInput formControlName="operator">
                      <mat-option *ngFor="let item of paramControl?.get('operators')?.value" [value]="item">
                        {{ item }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="paramControl?.get('operator')?.hasError('required')">This field is required</mat-error>
                  </mat-form-field>
                  <mat-form-field class="w-full" appearance="fill" *ngIf="paramControl.get('type')?.value">
                    <mat-label>Value</mat-label>
                    <ng-container [ngSwitch]="paramControl.get('type')?.value">
                      <ng-container *ngSwitchCase="'text'">
                        <ng-container *ngIf="paramControl.get('valueType')?.value === 'string'; else inputNumber">
                          <input matInput formControlName="value" type="text" />
                        </ng-container>
                        <ng-template #inputNumber>
                          <input matInput formControlName="value" mask="separator.4" type="text" />
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'selection'">
                        <mat-select matInput formControlName="value" [compareWith]="compareWithValueFilter">
                          <mat-option *ngFor="let item of paramControl?.get('options')?.value" [value]="item">
                            {{ item?.label }}
                          </mat-option>
                        </mat-select>
                      </ng-container>

                      <ng-container *ngSwitchCase="'multi-selection'">
                        <mat-select matInput formControlName="value" multiple [compareWith]="compareWithValueFilter">
                          <mat-select-trigger *ngIf="paramControl.get('value')?.value">
                            <div class="inline-flex items-baseline overflow-hidden w-full">
                              <div class="truncate mr-1">Number of values</div>
                              <mat-chip-list
                                [matTooltip]="paramControl.get('tooltipValues')?.value"
                                matTooltipClass="mat-tooltip-no-truncate"
                                class="whitespace-pre-line"
                              >
                                <mat-chip color="primary" selected>{{ paramControl?.get('numberOfValues')?.value }}</mat-chip>
                              </mat-chip-list>
                            </div>
                          </mat-select-trigger>
                          <!-- <mat-checkbox
                            id="mat-select-all-checkbox"
                            class="w-full mat-option"
                            color="primary"
                            (click)="$event.stopPropagation()"
                            (change)="addAllMultiSelections($event, paramControl)"
                            [checked]="paramControl?.get('numberOfValues')?.value === paramControl?.get('options')?.value?.length"
                            ><span [style]="paramControl?.get('numberOfValues')?.value === paramControl?.get('options')?.value?.length ? 'color: #e67425' : ''"
                              >Select All</span
                            ></mat-checkbox
                          > -->
                          <app-select-check-all [model]="valueControl(paramControl)" [values]="paramControl?.get('options')?.value"> </app-select-check-all>

                          <mat-option *ngFor="let item of paramControl?.get('options')?.value" [value]="item">
                            {{ item?.label }}
                          </mat-option>
                        </mat-select>
                      </ng-container>

                      <ng-container *ngSwitchCase="'date/single'">
                        <input matInput formControlName="value" [matDatepicker]="picker" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </ng-container>

                      <ng-container *ngSwitchCase="'date/range'">
                        <div class="flex items-center filter-date-range">
                          <input matInput formControlName="value" class="hidden" />
                          <mat-date-range-input formGroupName="range" required [rangePicker]="picker">
                            <input
                              matStartDate
                              formControlName="start"
                              readonly
                              placeholder="Start date"
                              (dateChange)="onDateRangeChange($event, paramControl, 'start')"
                            />
                            <input matEndDate formControlName="end" readonly placeholder="End date" (dateChange)="onDateRangeChange($event, paramControl, 'end')" />
                          </mat-date-range-input>
                          <mat-datepicker-toggle class="flex items-center" matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker (closed)="updateDateRange(paramControl)"></mat-date-range-picker>
                        </div>
                      </ng-container>
                    </ng-container>
                    <mat-error *ngIf="paramControl?.get('value')?.hasError('required')">This field is required</mat-error>
                  </mat-form-field>

                  <button mat-icon-button (click)="removeFilter(i)" *ngIf="!isDetail">
                    <mat-icon class="mb-4 text-primary">delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>
            <div class="flex flex-col flex-auto lg:mt-3" *ngIf="!isDetail">
              <button class="w-32" mat-button color="primary" (click)="addNewFilter()">
                <mat-icon>add</mat-icon>
                Add Filter
              </button>
            </div>
            <div class="flex flex-col flex-auto lg:mt-5" formGroupName="config">
              <div class="flex flex-col lg:flex-row items-center lg:gap-6">
                <mat-form-field class="w-full" appearance="fill">
                  <mat-label>Sort By</mat-label>
                  <mat-select matInput formControlName="orderBy">
                    <mat-option *ngFor="let item of colsFilter" [value]="item?.alias + '.' + item?.column">
                      {{ item?.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-full" appearance="fill">
                  <mat-label>Condition</mat-label>
                  <mat-select matInput formControlName="orderType">
                    <mat-option *ngFor="let item of sortTypeOptions" [value]="item?.id">
                      {{ item?.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="!isDetail"></div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-accordion>

    <!--Preview -->
    <div class="flex flex-col p-6 relative" *ngIf="!isDetail">
      <div class="flex flex-col flex-auto lg:max-w-[1200px] lg:mx-auto lg:my-0 w-full">
        <div class="flex flex-col flex-auto lg:mt-2" *ngIf="form?.get('reportType')?.value && form?.get('customColumns')?.value?.length > 0">
          <button class="w-32" mat-flat-button color="primary" type="button" [disabled]="isPreview" (click)="previewReport()">Preview</button>
        </div>
      </div>
    </div>
    <div class="flex flex-col px-6 pb-6" *ngIf="isPreview">
      <span class="text-s2"
        ><mat-icon matTooltipClass="line-broken-tooltip" class="icon-size-3 text-theme-gray">info</mat-icon>The table displays only 20 records for reference. The
        downloaded file will include all records that match the search criteria.</span
      >
      <div class="w-full overflow-auto mt-1 h-[390px] 2xl:h-[500px]">
        <red-dynamic-report-general-preview [data]="form.value" [reportType]="item?.reportType"></red-dynamic-report-general-preview>
      </div>
    </div>
  </form>
</div>
